<template>
  <div id="app">
    <ScaleBox>
      <LayoutIndex></LayoutIndex>
    </ScaleBox>
  </div>
</template>

<script>
import LayoutIndex from '@/views/layout/layout-index.vue'
import ScaleBox from "./components/scaleBox";
import seo from '@/seo.config'

export default {
  name: 'App',
  components:{
    LayoutIndex,
    ScaleBox
  },
  metaInfo() {
    const path = this.$route.path
    const isHome = path === '/'
    const label = seo.PAGE_LABELS[path] || seo.PAGE_LABELS['/']
    const crumb = seo.PAGE_BREADCRUMB[path]
    const url = seo.SITE_URL + path
    const title = isHome
      ? seo.COMPANY_NAME + ' - 化纤行业一站式方案提供服务商'
      : label + ' - ' + seo.COMPANY_NAME

    // 全局结构化数据：组织 + 站点（含站内搜索动作）
    const jsonLd = [
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: seo.COMPANY_NAME,
        url: seo.SITE_URL,
        description: seo.DEFAULT_DESCRIPTION
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: seo.COMPANY_NAME,
        url: seo.SITE_URL,
        potentialAction: {
          '@type': 'SearchAction',
          target: seo.SITE_URL + '/search?q={search_term_string}',
          'query-input': 'required name=search_term_string'
        }
      }
    ]

    // 内容页补充面包屑，帮助 AI 理解站点结构与层级
    if (crumb && crumb.length) {
      jsonLd.push({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: crumb.map((c, i) => ({
          '@type': 'ListItem',
          position: i + 1,
          name: c.name,
          item: seo.SITE_URL + c.url
        }))
      })
    }

    return {
      title: title,
      meta: [
        { vmid: 'description', name: 'description', content: seo.DEFAULT_DESCRIPTION }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: url }
      ],
      script: jsonLd.map((s, index) => ({
        vmid: 'site-jsonld-' + index,
        type: 'application/ld+json',
        json: s
      }))
    }
  },
  mounted() {
    // 通知预渲染器：首屏已渲染，可抓取静态 HTML（GEO）
    this.$nextTick(() => {
      document.dispatchEvent(new Event('prerender-ready'))
    })
  }
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
html,body{
  width: 100%;
  height: 100%;
}
#app {
  height: 100%;
  overflow: hidden;
  position: relative;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #000;
}
</style>



// WEBPACK FOOTER //
// src/App.vue